// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarSection_root"};